// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_Oa6","cls2":"JJHomePageSearch-cls2_sDt JJHomePageSearch-cls1_Oa6"};